import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 등록 확인 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 네고스탁에서")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 조합지분 판매 등록을 확인 하셨나요?")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 확인 하셨다면, 매물 등록을 완료합니다. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 네, 확인했어요 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_modal = _resolveComponent("ag-modal")!

  return (_openBlock(), _createBlock(_component_ag_modal, {
    height: "auto",
    "model-value": _ctx.isOpenRef,
    "safe-area": true,
    "swipe-to-close": true,
    "onUpdate:modelValue": _ctx.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, { handle: true }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_header, {
            title: "조합지분 팔기",
            onClose: _ctx.setOpen
          }, null, 8, ["onClose"]),
          _createVNode(_component_ag_box, {
            style: {"flex-direction":"column"},
            dp: "flex",
            mt: "60px",
            mb: "50px",
            "justify-content": "center",
            "align-items": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_img, { src: "/assets/svg/checkStroke.svg" }),
              _createVNode(_component_ag_text, {
                "text-align": 'center',
                "margin-top": "32px",
                "margin-bottom": "24px",
                typography: 'tit18b'
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, {
                "text-align": 'center',
                color: 'gray2',
                typography: 'main16r'
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_footer, {
            p: "20px",
            mb: "safeAreaBottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_button, {
                corner: '10px',
                width: '100%',
                onClickCapture: _ctx.setOpen
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClickCapture"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}